import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import withMessages from 'component-utilities/intl';

import ExportContent from './Export/ExportContent';
import ExportHeader from './Export/ExportHeader';
import ExportText from './Export/ExportText';
import ExportTextContainer from './Export/ExportTextContainer';
import styles from './Dropdowns.scss';

const BASE_KEY = 'components.dropdowns.export.views';

function component({ getMessage, goToExportsPage, onRetry, success, duplicated }) {
    const onClick = () => {
        if (success) return goToExportsPage;
        return onRetry;
    };

    let status;

    if (success) {
        status = duplicated ? 'dupe' : 'success';
    } else {
        status = 'error';
    }

    return (
        <div
            className={styles['dropdown-export']}
            data-dropdown={`export-${status}`}
        >
            <ExportHeader
                text={getMessage(`${BASE_KEY}.${status}.header`)}
            />
            <ExportContent>
                <ExportTextContainer>
                    <span className={styles[`export-${status}`]} />
                    <ExportText
                        size="regular"
                        messageKey={`${BASE_KEY}.${status}.message`}
                    />
                    <a
                        role="presentation"
                        className={styles['text-link']}
                        data-action={success ? 'go-to-exports' : 'retry'}
                        onClick={onClick()}
                    >
                        {getMessage(`${BASE_KEY}.${status}.link`)}
                    </a>
                </ExportTextContainer>
            </ExportContent>
        </div>
    );
}


component.propTypes = {
    getMessage: PropTypes.func.isRequired,
    goToExportsPage: PropTypes.func,
    onRetry: PropTypes.func,
    success: PropTypes.bool,
    duplicated: PropTypes.bool,
};

component.defaultProps = {
    goToExportsPage: null,
    onRetry: null,
    success: null,
    duplicated: null,
};

const ExportCompleteDropdown = withMessages(component);
ExportCompleteDropdown.displayName = displayName('Dropdowns/ExportCompleteDropdown');
export default ExportCompleteDropdown;
